import React  from 'react'
import { NavLink } from 'react-router-dom';
import { useContext } from 'react'
import AuthContext from './AuthContext';
import "./istyles.css";
import { useHistory } from "react-router-dom";

const Navbar3 = ({statuslogin}) => {

    const {gcsecurity} = useContext(AuthContext);
    const {gclang,setgclang} = useContext(AuthContext);
    const {gcusername} = useContext(AuthContext);  
    const {gnuserid} = useContext(AuthContext);  
    
    const history = useHistory();
    
    
    const handleLangChange = (lang, e) => {
      e.preventDefault();      
      setgclang((a) => (lang)); 
      if(lang === 'th'){
        history.push('/home');
      }
      else{
        history.push('/home_en');
      }

      /*
      if(lang === 'th'){

        const element = document.getElementById('a1');
        element.style.textDecorationLine = "underline";  
        
        const element2 = document.getElementById('a2');        
        element2.style.textDecorationLine = "";        
      }
        
      else {
        const element2 = document.getElementById('a2');
        element2.style.textDecorationLine = "underline";    
        
        const element = document.getElementById('a1');
        element.style.textDecorationLine = "";  
      }  
        */    
      
    };

    // Determine logo based on selected language
    const logoSrc = gclang === "th" ? "logo_cubest_th.jpg" : "logo_cubest_en.jpg";
            
    return (
    // <nav className="navbar navbar-expand-sm navbar-dark bg-primary">
    // <nav className="navbar navbar-expand-sm navbar-light bg-light">
    // <nav className="navbar navbar-expand-sm navbar-light bg-white">
    <nav class="navbar navbar-expand-lg navbar-light bg-white">

    
            <div className="container-fluid d-flex flex-lg-row flex-column align-items-center">           
            {/* <NavLink to="#" className="navbar-brand d-flex align-items-center"> */}
            <NavLink to="#" className="navbar-brand mx-lg-0 mx-auto">              
              {/* <img src='logocbsnew_resize.jpg' alt='Logo' className="d-inline-block align-top" style={{ width: '50%', height: '50%', objectFit: 'contain' }}/> */}
              {/* <img src='logo_cubest_th.jpg' alt='Logo' className="d-inline-block align-top" style={{ width: '50%', height: '50%', objectFit: 'contain' }}/> */}
              <img id='mylogo'  src={logoSrc} alt='Logo' className="d-inline-block align-top" style={{ maxWidth: '330px', height: 'auto' }}/>                            
            </NavLink>

            {
                   
                  //  statuslogin === 'login' ? (                     
                  //   <div className="lang-container">
                  //   <a 
                  //     id="a1"         
                  //     //className="lang-link me-2" 
                  //     className={`lang-link me-2 ${gclang === "th" ? "active" : ""}`}
                  //     onClick={(e) => handleLangChange("th", e)}
                  //   >
                  //     [th]
                  //   </a>
                  //   <a 
                  //     id="a2" 
                  //     //className="lang-link" 
                  //     className={`lang-link ${gclang === "en" ? "active" : ""}`}
                  //     onClick={(e) => handleLangChange("en", e)}
                  //   >
                  //     [en]
                  //   </a>
                  // </div>
                                              
                  //   ) : (
                  //    null                    
                  //  )                                                                            
                  }
                 
            {/* <div className="lang-container">
              <a 
                id="a1"         
                //className="lang-link me-2" 
                className={`lang-link me-2 ${gclang === "th" ? "active" : ""}`}
                onClick={(e) => handleLangChange("th", e)}
              >
                [th]
              </a>
              <a 
                id="a2" 
                //className="lang-link" 
                className={`lang-link ${gclang === "en" ? "active" : ""}`}
                onClick={(e) => handleLangChange("en", e)}
              >
                [en]
              </a>
            </div> */}

            {/* <button className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#x"> */}
            <button className="navbar-toggler order-lg-2 order-1 w-100 text-start mt-2 mt-lg-0" data-bs-toggle="collapse" data-bs-target="#x">              
                <span className="navbar-toggler-icon"></span>
            </button>

            {/* <div className="collapse navbar-collapse" id="x"> */}            
            <div className="collapse navbar-collapse justify-content-lg-end text-lg-end text-start order-lg-3 order-2" id="x">
                {/* <ul className="navbar-nav ms-auto"> */}
                <ul className="navbar-nav ms-lg-auto">
                                   
                  {                   
                   statuslogin === 'login' && gclang === 'th'? ( 
                      <>
                      <li className="nav-item">
                        <NavLink to="/home" className="nav-link" activeClassName="active-link">ประกาศ</NavLink>                                    
                      </li> 
                      {/* <li className="nav-item">
                        <NavLink to="/App_tid_pdf" className="nav-link" activeClassName="active-link">tid_pdf</NavLink>                                    
                      </li>  */}
                    </>                    
                                                             
                    ) : (
                     null                    
                   )                                                                            
                 }

                 {
                   
                   statuslogin === 'login' && gclang === 'en'? (                     
                    <li className="nav-item">
                      <NavLink to="/home_en" className="nav-link" activeClassName="active-link">Announcement</NavLink>                                    
                    </li>                                        
                    ) : (
                     null                    
                   )                                                                            
                  }

                       
                  {
                   
                    statuslogin !== 'login' && gclang === 'th'? (
                      <>
                       <li className="nav-item">
                        <NavLink to="/home" className="nav-link" activeClassName="active-link">ประกาศ</NavLink>                                    
                      </li>   
                      <li className="nav-item">
                        <NavLink to="/FrmProfile_th" className="nav-link" activeClassName="active-link">โปรไฟล์</NavLink>
                      </li>
                      <li className="nav-item">
                        <NavLink to="/FrmApplication_th" className="nav-link" activeClassName="active-link">ใบสมัคร</NavLink>
                      </li>  
                     <li className="nav-item">
                        <NavLink to="/FrmHisScore_th" className="nav-link" activeClassName="active-link">ประวัติการสมัครและผลคะแนน</NavLink>
                      </li>
                     
                       </>
                     ) : (
                      null                    
                    )                                                                            
                  } 
                    
                  {
                   
                   statuslogin !== 'login' && gclang === 'en'? (
                    <>
                    <li className="nav-item">
                      <NavLink to="/home_en" className="nav-link" activeClassName="active-link">Announcement</NavLink>                                    
                    </li> 
                    <li className="nav-item">
                      <NavLink to="/FrmProfile_en" className="nav-link" activeClassName="active-link">Profile</NavLink>
                    </li> 
                    <li className="nav-item">
                    <NavLink to="/FrmApplication_en" className="nav-link" activeClassName="active-link">Application</NavLink>
                    </li>  
                    <li className="nav-item">
                        <NavLink to="/FrmHisScore_en" className="nav-link" activeClassName="active-link">History and Result</NavLink>
                    </li>
                    </>
                    ) : (
                      null
                    )
                                       
                  } 


                  {                   
                   statuslogin === 'login' && gclang === 'th'? (                     
                    <li className="nav-item">
                    <NavLink to="/FrmNewRegister_th" className="nav-link" activeClassName="active-link">ลงทะเบียนใหม่</NavLink>
                    </li>                  
                    ) : (
                     null                    
                   )                                                                            
                 }   

                  {                   
                   statuslogin === 'login' && gclang === 'en'? (                     
                    <li className="nav-item">
                      <NavLink to="/FrmNewRegister_en" className="nav-link" activeClassName="active-link">Register</NavLink>                                    
                    </li>
                    ) : (
                     null                    
                   )                                                                            
                 }                         
                  
                 


                  {/* 
                   statuslogin === 'login' && gclang === 'th'? (                    
                    <li className="nav-item">
                        <NavLink to="/login" className="nav-link">เข้าสู่ระบบ</NavLink>
                    </li>  
                    ) : (
                      <li className="nav-item">
                        <NavLink to="/login_en" className="nav-link">Login</NavLink>
                    </li>  
                    )                                                                           
                  */}  


                  { statuslogin === 'login'  ? (<li className="nav-item">
                        <NavLink to="/login" className="nav-link active" title="Click to login"><i class="fa fa-user-circle" aria-hidden="true"></i>&nbsp;{statuslogin}</NavLink>
                    </li>) :(<li className="nav-item">
                        <NavLink to="/logout" className="nav-link active btn-black" title={`${gcusername}`}><i class="fa fa-user-circle" aria-hidden="true"></i>&nbsp;{statuslogin}</NavLink>
                    </li>) } 

                    
                   

                   
                    {
                       
                        /*  
                        gcsecurity && gcsecurity.map( (d,index) => {

                            
                            // if(d.filename === 'mastersfrmtemplate' && d.isenabled === true)
                            if(d.filename === 'mastersfrmtemplate')
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/mastersfrmtemplate/FrmQCat" className="nav-link">Category</NavLink>
                                </li>    
                             
                              )
            
                            }

                            if(d.filename === 'upload' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/upload" className="nav-link">Upload</NavLink>
                                </li>    
                             
                              )
            
                            }


                            if(d.filename === 'Import' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/Import" className="nav-link">Import</NavLink>                                    
                                </li>    
                             
                              )
            
                            }


                            if(d.filename === 'FrmExam' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/FrmExam" className="nav-link">Exam</NavLink>                                    
                                </li>    
                             
                              )
            
                            }

                            if(d.filename === 'FrmExamReuse' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/FrmExamReuse" className="nav-link">Reuse</NavLink>                                   
                                </li>    
                             
                              )
            
                            }

                            if(d.filename === 'FrmSearch' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/FrmSearch" className="nav-link">Search</NavLink>
                                    
                                </li>    
                             
                              )
            
                            }

                            if(d.filename === 'FrmDocx' && d.isenabled === true)
                              {
                                return(
                                  <li className="nav-item">
                                      <NavLink to="/FrmDocx" className="nav-link">Docx</NavLink>
                                      
                                  </li>    
                               
                                )
              
                              }

                            if(d.filename === 'Frmbackupdb' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/Frmbackupdb" className="nav-link">Backup</NavLink>
                                    
                                </li>    
                             
                              )
            
                            }


                            if(d.filename === 'FrmSecurity' && d.isenabled === true)
                            {
                              return(
                                <li className="nav-item">
                                    <NavLink to="/FrmSecurity/Frmusermenu" className="nav-link">Security</NavLink>
                                    
                                </li>    
                             
                              )
            
                            }
                        
                        })
                        */

                    }

                                                                               


                    {/* <li className="nav-item">
                        <NavLink to="/login" className="nav-link active btn-danger">{statuslogin}</NavLink>
                    </li>             */}
                    
                </ul>
                
            </div>
        </div>    
    
    </nav>
)
   
}

export default Navbar3